// extracted by mini-css-extract-plugin
export var chip = "_9q-0";
export var filterDropdown = "_9q-5";
export var filterItem = "_9q-6";
export var icon = "_9q-1";
export var removeButton = "_9q-3";
export var removeIcon = "_9q-4";
export var separator = "_9q-2";